'use client'

import { useState } from 'react'
import { copyTextToClipboard } from 'src/_helpers/copyToClipboard'
import Typography from './Typography'
import ProductTile from './ProductTile'

const TILE_DATA = {
  imageSrc: 'https://placehold.co/190x278',
  imageAlt: 'Okładka magazynu Barok',
  title: 'Egipska popkrólowa for people and the environment',
  subtitle: 'Okruchy świadectw. Napisy, inskrypcje, inicjały, glosy w kulturze',
  metadata: ['Numer 30, Tom 43, 2024', 'DOI:10.4467/168908909AP', 'Wydział Filozofii'],
  footerLines: ['Adam Kowalczyk, Joanna Poprawska'],
  tags: [
    { label: 'Nowość', type: 'new' },
    { label: 'Tag label', type: 'default' },
    { label: 'Tag label', type: 'default' },
  ],
  ctaLabel: 'Zobacz więcej',
  ctaHref: '#',
}

const generateCodeSnippet = () => {
  return `<ProductTile
  imageSrc="${TILE_DATA.imageSrc}"
  imageAlt="${TILE_DATA.imageAlt}"
  tags={[
    { label: 'Nowość', type: 'new' },
    { label: 'Tag label', type: 'default' },
    { label: 'Tag label', type: 'default' },
  ]}
  title="${TILE_DATA.title}"
  subtitle="${TILE_DATA.subtitle}"
  metadata={[
    'Numer 30, Tom 43, 2024',
    'DOI:10.4467/168908909AP',
    'Wydział Filozofii',
  ]}
  footerLines={[
    'Adam Kowalczyk, Joanna Poprawska',
  ]}
  ctaLabel="${TILE_DATA.ctaLabel}"
  ctaHref="${TILE_DATA.ctaHref}"
/>`
}

const ProductTileCard = () => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    const success = await copyTextToClipboard(generateCodeSnippet())
    if (!success) return

    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="flex flex-col gap-8 p-16 border border-basic-gray6 rounded-lg bg-basic-white">
      <div className="flex items-center justify-between">
        <Typography variant="body3">Default</Typography>
        <button
          onClick={handleCopy}
          className="px-4 py-1 text-xs bg-basic-gray6 hover:bg-basic-gray5 text-basic-black rounded transition-colors"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>

      <ProductTile {...TILE_DATA} />

      <code className="block text-xs text-basic-gray3 bg-basic-gray8 rounded px-4 py-2 whitespace-pre overflow-x-auto">
        {generateCodeSnippet()}
      </code>
    </div>
  )
}

export default function ProductTileExamples() {
  return (
    <div className="space-y-24">
      <Typography variant="h2">Product Tile</Typography>

      <Typography variant="body1">
        Card component presenting publication metadata. The whole tile is clickable via <code>ctaHref</code>, with a CTA
        label revealed on hover/focus plus tag strip, title, subtitle, and structured metadata.
      </Typography>

      <ProductTileCard />
    </div>
  )
}
